import { useAuth } from "../../modules/auth"
import { createContext } from "react"
import { ITutorialContext } from "./models"
import { TUTORIAL_GLOBAL_STEPS } from "./steps/global"
import Joyride from "react-joyride"
import useTutorialProfile from "./hooks/useTutorialProfile"
import useTutorialGlobal from "./hooks/useTutorialGlobal"
import { TUTORIAL_PROFILE_STEPS } from "./steps/profile"

const Tutorial = () => {
     const { interactiveTutorial } = useAuth()
     const { handleJoyrideCallback: handleJoyrideCallback__global } = useTutorialGlobal()
     const { handleJoyrideCallback: handleJoyrideCallback__profile } = useTutorialProfile()

     const steps = (() => {
          if (interactiveTutorial.target === "PROFIL_ONLY") return TUTORIAL_PROFILE_STEPS

          return TUTORIAL_GLOBAL_STEPS
     })()

     return (
          <TutorialContext.Provider value={{}}>
               <Joyride
                    steps={steps}
                    run={true}
                    continuous
                    stepIndex={interactiveTutorial.stepIndex || 0}
                    showSkipButton
                    scrollToFirstStep
                    hideCloseButton
                    disableCloseOnEsc
                    scrollOffset={80}
                    disableOverlayClose
                    callback={props => {
                         if (interactiveTutorial.target === "PROFIL_ONLY") {
                              handleJoyrideCallback__profile(props)
                              return
                         }

                         handleJoyrideCallback__global(props)
                    }}
                    styles={{
                         options: {
                              zIndex: 10000,
                         },
                    }}
                    locale={{
                         back: "Précédent",
                         close: "Fermer",
                         last: "Terminé",
                         next: "Suivant",
                         skip: "Ignorer",
                    }}
               />

               {/*{interactiveTutorial.target === "GLOBAL" && <GlobalTutorial />}*/}
          </TutorialContext.Provider>
     )
}

const TutorialContext = createContext<ITutorialContext>({} as ITutorialContext)

export { Tutorial, TutorialContext }
